<template>
  <div v-if="show" class="text-[var(--text)] gap-1 p-1 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half" id="form_btn_container">
    <div style="display: flex; justify-content: space-between; align-items: center"
    >
    <h3 class="text-[18px] font-bold" style="color: var(--titulo)" >{{ form_title }}</h3>
      <div class="flex items-center gap-2">
        <HistoricoObjetoButton
          model-name="Equipamento"
          :objeto-id="form_data.id"
          modelo-label="Equipamento"
          variant="bare"
          icon-only
        />
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="input_container">
          <label for="codigo" class="input_label">Codigo:</label>
          <input
              :disabled="form_data.status == 'desativado'"
              type="text"
              v-model="form_data.codigo"
              placeholder="Codigo"
              class="w-full text-[20px] p-1 rounded-[5px]"
              :class="{ 'input-required': !form_data.codigo }"
            />
        </div>

        <div class="input_container">
          <label for="utilizador" class="input_label">Nome:</label>
          <input
              :disabled="form_data.status == 'desativado'"
              type="text"
              v-model="form_data.nome"
              placeholder="Nome"
              class="w-full text-[20px] p-1 rounded-[5px]"
              :class="{ 'input-required': !form_data.nome }"
            />
        </div>

        <div style="display: flex">
          <label style="min-width: 76px">Descriçao:</label>
          <textarea
            :disabled="form_data.status === 'desativado'"
            v-model="form_data.descricao"
            placeholder="Descrição"
            class="input_field textarea"
          ></textarea>
        </div>

        <div class="data_set_class">
          <div class="data_set">
            <div style="min-width: 142px">Familia:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{color: set_data.familia.nome == '' || !set_data.familia.nome ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              {{
                set_data.familia.nome == "" || !set_data.familia.nome
                  ? "N/A"
                  : set_data.familia.nome
              }}
              <button
                class="flex items-center"
                :style="{
                  color:
                    form_data.status == 'desativado' ? '#7B7B99' : 'var(--icon)',
                }"
                :disabled="form_data.status == 'desativado'"
                @click="open_dialog_alert('familia')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>

          <div class="data_set">
            <div style="min-width: 142px">Produto:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{
                color:
                  set_data.produto.produto == '' || !set_data.produto.produto
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              <!-- {{ set_data.produto.nome -->
              {{
                set_data.produto.produto == "" || !set_data.produto.produto
                  ? "N/A"
                  : set_data.produto.produto
              }}
              <button
                class="flex items-center"
                :style="{ color: iconColor('produto') }"
                :disabled="form_data.status == 'desativado' || !canSelect('produto')"
                :title="!canSelect('produto') ? 'Selecione primeiro a Família' : ''"
                @click="open_dialog_alert('produto')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>
          <div class="data_set">
            <div style="min-width: 142px">Tipologia:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{
                color:
                  set_data.tipologia.nome == '' || !set_data.tipologia.nome
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              {{
                set_data.tipologia.nome == "" || !set_data.tipologia.nome
                  ? "N/A"
                  : set_data.tipologia.nome
              }}
              <button
                class="flex items-center"
                :style="{ color: iconColor('tipologia') }"
                :disabled="form_data.status == 'desativado' || !canSelect('tipologia')"
                :title="!canSelect('tipologia') ? 'Selecione primeiro o Produto' : ''"
                @click="open_dialog_alert('tipologia')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>
          <div class="data_set">
            <div style="min-width: 142px">Medida:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{
                color:
                  set_data.medida.nome == '' || !set_data.medida.nome
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >
              {{
                set_data.medida.nome == "" || !set_data.medida.nome
                  ? "N/A"
                  : set_data.medida.nome
              }}
              <button
                class="flex items-center"
                :style="{ color: iconColor('tpmedida') }"
                :disabled="form_data.status == 'desativado' || !canSelect('tpmedida')"
                :title="!canSelect('tpmedida') ? 'Selecione primeiro a Tipologia' : ''"
                @click="open_dialog_alert('tpmedida')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>
          <div class="data_set">
            <div style="min-width: 142px">Marca:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{
                color:
                  set_data.marca.nome == '' || !set_data.marca.nome
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >{{set_data.marca.nome == "" || !set_data.marca.nome? "N/A": set_data.marca.nome}}
              <button
                class="flex items-center"
                :style="{ color: iconColor('tpmarca') }"
                :disabled="form_data.status == 'desativado' || !canSelect('tpmarca')"
                :title="!canSelect('tpmarca') ? 'Selecione primeiro a Medida' : ''"
                @click="open_dialog_alert('tpmarca')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>
          <div class="data_set">
            <div style="min-width: 142px">Servico:</div>
            <div
              class="flex justify-between items-center gap-1"
              :style="{
                color:
                  set_data.servico.nome == '' || !set_data.servico.nome
                    ? 'var(--obrigatorio)'
                    : 'var(--icon)',
              }"
            >{{set_data.servico.nome == "" || !set_data.servico.nome? "N/A": set_data.servico.nome}}
            </div>
          </div>
          <div class="data_set">
            <div for="codigo" class="min-w-[142px]">Referencia:</div>
            <input
            style="color: var(--text); background-color: var(--label);"

              type="text"
              v-model="form_data.referencia"
              placeholder="Referencia"
              class="input_field text-black"
              />
              <!-- :disabled="form_data.status === 'desativado' || !create_btn" -->
          </div>
          <div v-if="podeGerir && set_data.marca.id===1 && !create_btn && (!set_data.servico || set_data.servico.id===0)" class="data_set">
            <div style="min-width: 142px">Replicar Equipamento:</div>
            <div
              class="flex justify-between items-center gap-1"
            >
              <button
                class="flex items-center"
                :style="{color:form_data.status == 'desativado' ? '#7B7B99' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="open_dialog_alert('replica')"
              >
                <Icon class="edit-icon" icon="lucide:edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="right_form" class="right_form">
        <div class="img_container">
          <div class="img_btn_container">
            <div class="img_container">
              <img
                id="equipamento_img"
                :src="form_data.foto"
                alt="equipamento image"
              />
            </div>

            <div style="margin-top: 0.5rem">
              <label for="input-file">
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  style="color: var(--icon); cursor: pointer"
                ></i>
              </label>
              <input
                type="file"
                accept="image/*"
                id="input-file"
                @change="upload_img"
                hidden
                :disabled="form_data.status === 'desativado'"
              />
            </div>
          </div>
        </div>
        <div class="p-2 flex flex-col gap-2">
          <div class="flex justify-between">
            <div class="text-[var(--text)] w-28 text-sm">Compra Minima:</div>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model="precoEquipamento.compraMin"
              placeholder="0"
              :disabled="true"
              class="w-32 rounded-md px-1 text-sm"
            />
          </div>
          <div class="flex justify-between">
            <div class="text-[var(--text)] w-28 text-sm">Compra Media:</div>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model="precoEquipamento.compraMed"
              placeholder="0"
              :disabled="true"
              class="w-32 rounded-md px-1 text-sm"
            />
          </div>
          <div class="flex justify-between">
            <div class="text-[var(--text)] w-28 text-sm">Compra Atual:</div>
            <input
            style="color: var(--text); background-color: var(--label);"
              type="number"
              step="0.01"
              min="0"
              v-model="precoEquipamento.compraAtual"
              placeholder="0"
              class="w-32 rounded-md px-1 text-sm"
              :disabled="form_data.status === 'desativado'"
            />
          </div>
          <div class="flex justify-between">
            <div class="text-[var(--text)] w-28 text-sm">Venda min:</div>
            <input
            style="color: var(--text); background-color: var(--label);"

              type="number"
              step="0.01"
              min="0"
              v-model="precoEquipamento.vendaMin"
              placeholder="0"
              class="w-32 rounded-md px-1 text-sm"
              :disabled="form_data.status === 'desativado'"
            />
          </div>
          <div class="flex justify-between">
            <div class="text-[var(--text)] w-28 text-sm">Venda:</div>
            <input
            style="color: var(--text); background-color: var(--label);"

              type="number"
              step="0.01"
              min="0"
              v-model="precoEquipamento.venda"
              placeholder="0"
              class="w-32 rounded-md px-1 text-sm"
              :disabled="form_data.status === 'desativado'"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; gap: 0.5rem">
      <button
        v-if="podeGerir && create_btn && this.validPermission('E0015')"
        class="btn"
        @click="showConfirm($event, 'create')"
        :font_size="14"
      >Criar</button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('E0016') && form_data.status === 'ativo'"
        class="btn"
        :style="{backgroundColor: 'rgb(0, 102, 152)',}"
        @click="showConfirm($event, 'update')"
        :font_size="14"
      >Atualizar</button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('E0017') && form_data.status ==='ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'red' }" 
        @click="showConfirm($event, 'disable')">Desativar</button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('E0017') && form_data.status ==='desativado'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'disable')">Ativar</button>     
      <ConfirmPopUp ref="myConfirm" @accept="onAccept" :message="askMessage" />
    </div>

  <Dialog
      v-if="showDialog"
      :propsData="dialogProps"
      @close="closeDialog"
      @returnData="handleReturnData"
      :multiSelectOptions="{ enabled: multiSelectEnabled, show_btn: false }"
      :pagination="paginationEnabled"
    />
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import permissionMixin from "@/permissionMixin.js";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import { toast } from "vue3-toastify";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  mixins: [permissionMixin],
  name: "AppEquipamentosForm",
  components: {
    AppButton,
    ConfirmPopUp,
    Dialog,
    HistoricoObjetoButton,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    precoEquipamento: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    podeGerir: {
      type: Boolean,
      default: () => true,
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
    update_visibility: {
      type: Boolean,
      default: () => false,
    },
    disable_visibility: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showDialog: false,
      dialogProps: {
        entity: ["familia", "produto", "tpmarca", "tpmedida", "tipologia"],
        sideBar: true,
        multi: false,
            // queryParams: { 'produto': `` },
        specialQuery: {},
        },
      emit_type: "",
      multiSelectEnabled: false,
      paginationEnabled:true,
      listaReplica: {},
      invalidData: [
        "N/A",
        "SEM MARCA",
        "SEM MEDIDA",
        "SEM TIPOLOGIA",
        "SEM PRODUTO",
        "SEM FAMILIA",
      ],
    };
  },
  created() {
    // this.form_data.nome = this.customNome();
  },


  methods: {
    closeDialog() {
          this.showDialog = false;
      },

    // Verifica se um campo do set_data já foi escolhido.
    // Conta como escolha qualquer registo com id válido — incluindo as
    // opções "Sem Tipologia/Medida/Marca" (têm id próprio) — para que a
    // ordem continue a permitir avançar mesmo sem tipologia/medida/marca.
    isFieldSelected(field) {
      const obj = this.set_data?.[field];
      if (!obj) return false;
      return Number(obj.id) > 0;
    },

    // Indica se o campo pode ser selecionado, respeitando a ordem obrigatória
    canSelect(key) {
      const requires = {
        produto: "familia",
        tipologia: "produto",
        tpmedida: "tipologia",
        tpmarca: "medida",
      };
      const req = requires[key];
      if (!req) return true;
      return this.isFieldSelected(req);
    },

    // Cor do ícone: cinza quando desativado ou bloqueado pela ordem
    iconColor(key) {
      if (this.form_data.status == "desativado") return "#7B7B99";
      if (!this.canSelect(key)) return "#7B7B99";
      return "var(--icon)";
    },

    open_dialog_alert(key) {
        // Ordem obrigatória: familia -> produto -> tipologia -> medida -> marca
        const requires = {
          produto: { field: "familia", label: "Família" },
          tipologia: { field: "produto", label: "Produto" },
          tpmedida: { field: "tipologia", label: "Tipologia" },
          tpmarca: { field: "medida", label: "Medida" },
        };
        const req = requires[key];
        if (req && !this.isFieldSelected(req.field)) {
          toast.warning(`Selecione primeiro: ${req.label}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1500,
          });
          return;
        }
        if (key == "familia") {
          //se a rota da familia é pagination coloca pagination true, se é multiselect coloca multiselect true
          this.dialogProps.entity[0] = "familia";
          this.dialogProps.finalUrl = "l=1";
          this.currentType = "familia";
          this.multiSelectEnabled = false;
          this.paginationEnabled = true;
          this.showDialog = true;
        } else if (key == "produto") {
          this.dialogProps.entity[0] = "produto";
          // Filtra os produtos pela família selecionada (endpoint de paginação aceita familia_id)
          this.dialogProps.finalUrl = `familia_id=${this.set_data.familia.id}&status=ativo&l=1`;
          this.currentType = "produto";
          this.multiSelectEnabled = false;
          this.paginationEnabled = true;
          this.showDialog = true;
        } else if (key == "tipologia") {
          this.dialogProps.entity[0] = "tipologia";
          // Filtra as tipologias pela família + produto selecionados
          this.dialogProps.finalUrl = `familia_id=${this.set_data.familia.id}&produto_id=${this.set_data.produto.id}&status=ativo&l=1`;
          this.currentType = "tipologia";
          this.multiSelectEnabled = false;
          this.paginationEnabled = true;
          this.showDialog = true;
        } else if (key == "tpmedida") {
          this.dialogProps.entity[0] = "tpmedida";
          this.dialogProps.finalUrl = "l=1";
          this.currentType = "tpmedida";
          this.multiSelectEnabled = false;
          this.paginationEnabled = true;
          this.showDialog = true;
        } else if (key == "tpmarca") {
          this.dialogProps.entity[0] = "tpmarca";
          this.dialogProps.finalUrl = "l=1";
          this.currentType = "tpmarca";
          this.multiSelectEnabled = false;
          this.paginationEnabled = true;
          this.showDialog = true;
        } else if (key == "replica") {
          //se a rota da replica é pagination coloca pagination true, se é multiselect coloca multiselect true
          this.dialogProps.entity[0] = "tpmarca";
          this.currentType = "replica";
          this.dialogProps.title = "replica";
          this.multiSelectEnabled = true;
          this.paginationEnabled = true;  
          this.showDialog = true;
        }
      },

      async handleReturnData(data) {
        console.log(data)
        if (data.familia) {
          if (this.set_data.familia.id !== data.familia.id) {
            this.set_data.produto = { id: 0, produto: "" };
            this.set_data.tipologia = { id: 0, nome: "" };
            this.set_data.marca = { id: 0, nome: "" };
            this.set_data.medida = { id: 0, nome: "" };
          }
          this.set_data.familia = data.familia;
        }
        if (data.produto) {
          // Produto mudou -> limpa os campos a jusante (mantém a ordem)
          if (this.set_data.produto?.id !== data.produto.id) {
            this.set_data.tipologia = { id: 0, nome: "" };
            this.set_data.medida = { id: 0, nome: "" };
            this.set_data.marca = { id: 0, nome: "" };
          }
          this.set_data.produto = data.produto;
        }
        if (data.tipologia) 
        {
          this.set_data.tipologia = data.tipologia;
        }
        if (data.tpmarca)
        {
          this.set_data.marca = data.tpmarca;
        }
        if (data.tpmedida) {
          this.set_data.medida = data.tpmedida;
        }
        if (data.replica) {
          //this.set_data.medida = data.tpmedida;
          this.listaReplica=data.replica
          console.log("REPLICA",this.listaReplica)
          this.replica(this.listaReplica)
          this.close()
        }
        this.form_data.nome=this.customNome()
        this.form_data.codigo=this.customCodigo()

      },

      customCodigo() {
      const getTwoDigits = (txt = "") => {
        if (!txt) return "";
        const val = txt.trim().toUpperCase();
        if (this.invalidData.includes(val)) return "";

        if (/^\d+$/.test(val)) {
          return val.length === 1 ? "0" + val : val.substring(0, 2);
        }
        return val.substring(0, 2);
      };

      let familia2 = getTwoDigits(this.set_data?.familia?.nome);
      let produto2 = getTwoDigits(this.set_data?.produto?.produto);
      let tipologia2 = getTwoDigits(this.set_data?.tipologia?.nome);
      let medida2 = getTwoDigits(this.set_data?.medida?.nome);
      let marca2 = getTwoDigits(this.set_data?.marca?.nome);

      if (familia2 === produto2) {
        familia2 = "";
      }

      return familia2 + produto2 + tipologia2 + medida2 + marca2;
    },

    customNome() {
      const validateData = (data, campo) => {
        try {
          data[campo] = data[campo].toUpperCase();
        } catch (error) {
          console.log("error ao uppcase da data:", error);
        }
        let invalidData = [
          "N/A",
          "SEM MARCA",
          "SEM MEDIDA",
          "SEM TIPOLOGIA",
          "SEM PRODUTO",
          "SEM FAMILIA",
        ];
        if (!data || invalidData.includes(data[campo])) {
          return "";
        }
        return data[campo];
      };

      let dataParts = [
        // validateData(this.set_data?.familia, "nome"),
        validateData(this.set_data?.produto, "produto"),
        validateData(this.set_data?.tipologia, "nome"),
        validateData(this.set_data?.medida, "nome"),
        validateData(this.set_data?.marca, "nome"),
      ];
      // Remove partes vazias
      dataParts = dataParts.filter((part) => part);

      // Remover termos que estão contidos em outros mais específicos
      const refinedParts = dataParts.filter((part, index, arr) => {
        return !arr.some((other, i) => i !== index && other.includes(part));
      });

      const customNome = refinedParts.join(" ").replace(/\s+/g, " ").trim();
      return customNome;
    },


    handlingTosat(message) {
      toast.warning(`${message} e obrigatorio!`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
    },
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        this.update();
      } else if (this.emit_type == "disable") {
        this.disable();
      } else {
        this.$emit("show_table", this.emit_type);
      }
      console.log("Confirmed!");
    },
    selectTable(name) {
      // Logic to handle selecting armazem
      this.$emit("show_table", name);
    },

    upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("equipamento_img");
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
        const formData = new FormData();
        formData.append("foto", file);
        this.form_data.newFoto = formData;
      }
    },
    create() {
      if (!this.isValidForm()) return;
      const formData = this.getFormData();
      console.log(this.precoEquipamento)
      this.$emit("create", formData, this.precoEquipamento);
    },

    update() {
      if (!this.isValidForm()) return;
      const formData = this.getFormData();
      this.$emit("update", formData, this.precoEquipamento);
    },

    disable() {
      //if(!this.isValidForm()) return
      const formData = this.getFormData();
      this.$emit("disable", formData);
    },

    replica(data) {
      const formData = this.getFormData();
      this.$emit("replica", formData, data); 
    },

    isValidForm() {
      // Validate if codigo is not empty
      if (!this.form_data.codigo) {
        this.handlingTosat("codigo");
        return false;
      }

      // Validate if nome is not empty (editável também em modo edição)
      if (!this.form_data.nome || !this.form_data.nome.trim()) {
        this.handlingTosat("nome");
        return false;
      }

      // Validate if marca is selected
      if (this.set_data.marca.nome == "N/A" || !this.set_data.marca.nome) {
        this.handlingTosat("marca");
        return false;
      }

      // Validate if medida is selected
      if (!this.set_data.medida.nome) {
        this.handlingTosat("medida");
        return false;
      }

      // Validate if tipologia is selected
      if (!this.set_data.tipologia.nome) {
        this.handlingTosat("tipologia");
        return false;
      }

      // If all validations pass, return true
      return true;
    },

    getFormData() {
      const formDataObject = {
        ...this.form_data,
        ...this.set_data,
      };

      return formDataObject;
    },

    close() {
      this.$emit("close");
    },

    isEmptyField(field) {
      if (["codigo", "nome"].includes(field)) {
        return (
          this.form_data[field] === "" || Array.isArray(this.form_data[field])
        );
      }
      return false;
    },

    resetSet_data() {
      this.set_data.marca = {};
      this.set_data.medida = {};
      this.set_data.tipologia = {};
      this.set_data.produto = {};
      this.set_data.familia = {};
    },
  },


  watch: {
    //J...
    set_data: {
      deep: true,
      immediate: true,
      handler() {
      },
    },
    form_data: {
      deep: true,
      handler() {
      },
    },
  },
};
</script>

<style scoped>

.edit-icon {
  font-size: 1.5em;
  color: var(--icon);
  cursor: pointer;
}

.remove-icon {
  font-size: 1.5em;
  filter: drop-shadow(0 0 2px var(--obrigatorio));
  color: var(--obrigatorio);
  cursor: pointer;
}

.form_btn_container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--fundoForm);
  padding: 1px;
}

.form_container {
  display: flex;
  gap: 2px;
  padding: 1px;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  /* gap: 0.2rem; */
  gap: 1rem;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: var(--label);
}

label {
  display: block;
  color: var(--label);
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
input[type="password"],
select {
  padding: 0.3rem;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid var(--glass-border);
}

.input_field.textarea {
  /* Define width and height as needed */
  width: 200px;
  height: 60px;
  color: var(--text);
  /* Add other styles as needed */
}

.btn_div {
  color: var(--label);
  display: flex;
  padding-left: 1rem;
  align-items: center;
  gap: 0.6rem;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.3rem;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.data_set {
  font-size: 14px;
  color: var(--label);
  display: flex;
  min-width: 23em;
  justify-content: space-between;
  /* gap: 0.3rem;*/
}

.right_form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  align-items: center;
  /* display: none; */
}

.img_signature_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.signature_container {
  display: flex;
}

.tpa_certificado_container {
  display: flex;
  flex-direction: column;
}

.signature_div {
  display: flex;
  gap: 1rem;
}

.signature_field_container {
  display: flex;
  width: 200px;
  height: auto;
  background-color: var(--fundoComponente);
  border-radius: 0.2rem;
}

.signature_field_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.2rem;
}

.signature_icon_container {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  padding-top: 1rem;
}

.contato_container {
  padding: 0.3rem;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 0.5rem;
}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 100px;
  /* Adjust label width as needed */
  color: var(--label);
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--fundoApp);
  background-color: var(--label);
}

.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}



.ser_data {
  display: flex;
  align-items: center; /* Alinha o texto verticalmente ao centro */
  justify-content: space-between; /* Espaça os rótulos e valores */
  gap: 0.5rem; /* Espaçamento entre os itens */
}

.ser_data label {
  min-width: 120px; /* Define uma largura mínima fixa para os rótulos */
  text-align: left; /* Alinha os rótulos à esquerda */
  font-weight: bold; /* Destaca os rótulos */
  color: var(--label); /* Cor branca para os rótulos */
}

.ser_data div {
  flex-grow: 1; /* Faz o valor ocupar o espaço restante */
  color: var(--icon); /* Define a cor padrão do texto */
  text-align: left; /* Alinha o texto à esquerda */
  word-break: break-word; /* Permite quebra de linha no texto */
}

.ser_data button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
}

.ser_data button:disabled {
  cursor: not-allowed;
  color: var(--desativado);
}
</style>